'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRadioTower = function GoRadioTower(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12 15.3c0.6-0.7 0.6-1.7 0-2.3-0.8-0.9-1.2-1.9-1.2-3 0-1.1 0.4-2.2 1.2-3 0.6-0.6 0.6-1.7 0-2.3-0.3-0.3-0.7-0.5-1.1-0.5-0.4 0-0.8 0.2-1.2 0.5-1.4 1.5-2.1 3.4-2.1 5.3 0 1.9 0.7 3.8 2.1 5.3 0.7 0.6 1.7 0.6 2.3 0z m-6.2-14c-0.3-0.3-0.7-0.5-1.1-0.5-0.4 0-0.8 0.2-1.2 0.5-2.3 2.4-3.5 5.5-3.5 8.7 0 3.1 1.2 6.3 3.5 8.7 0.7 0.6 1.7 0.6 2.3 0 0.7-0.7 0.7-1.7 0-2.4-1.7-1.7-2.5-4-2.5-6.3s0.8-4.6 2.5-6.4c0.7-0.6 0.7-1.7 0-2.3z m14.2 12.8c2.3 0 4.1-1.9 4.1-4.1s-1.8-4.1-4.1-4.1c-2.2 0-4 1.9-4 4.1s1.8 4.1 4 4.1z m16.5-12.8c-0.7-0.6-1.7-0.6-2.3 0-0.6 0.7-0.6 1.7 0 2.4 1.7 1.7 2.5 4 2.5 6.3 0 2.3-0.8 4.6-2.5 6.3-0.7 0.7-0.7 1.7 0 2.4 0.3 0.3 0.7 0.5 1.1 0.5 0.4 0 0.8-0.2 1.2-0.5 2.3-2.4 3.5-5.6 3.5-8.7 0-3.1-1.2-6.3-3.5-8.7z m-16.4 16c-1.1 0-2.1-0.3-3.1-0.8l-7.8 21h3.7l2.1-2.5h10l2.1 2.5h3.8l-7.9-21c-0.9 0.5-1.9 0.8-3 0.8z m-0.1 1.2l2.5 9h-5l2.5-9z m-5 14l2.5-2.5h5l2.5 2.5h-10z m13-27.8c-0.6 0.7-0.6 1.7 0 2.3 0.8 0.9 1.2 1.9 1.2 3 0 1.1-0.4 2.2-1.2 3-0.6 0.6-0.6 1.7 0 2.3 0.3 0.3 0.7 0.5 1.1 0.5 0.4 0 0.8-0.2 1.2-0.5 1.4-1.5 2.1-3.4 2.1-5.3 0-1.9-0.7-3.8-2.1-5.3-0.7-0.6-1.7-0.6-2.3 0z' })
        )
    );
};

exports.default = GoRadioTower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/radio-tower.js
// module id = 2243
// module chunks = 168707334958949